﻿import FeatureForm from "@arcgis/core/widgets/FeatureForm";
import {buildJsGraphic} from "./jsBuilder";
import {DotNetGraphic} from "./definitions";
import {graphicsRefs} from "./arcGisJsInterop";


export default class FeatureFormWidgetWrapper {
    private featureForm: FeatureForm;
    
    constructor(featureForm: FeatureForm) {
        this.featureForm = featureForm;
    }
    
    setFeature(feature: DotNetGraphic, viewId: string) {
        if (feature === null) {
            this.featureForm.feature = null;
            return;
        }
        let graphic;
        if (graphicsRefs.hasOwnProperty(feature.id)) {
            graphic = graphicsRefs[feature.id];
        } else {
            graphic = buildJsGraphic(feature, viewId);
        }
        this.featureForm.feature = graphic;
    }
    
    getValues(): any {
        return this.featureForm.getValues();
    }
    
    submit(): void {
        this.featureForm.submit();
    }
}